export default "__VITE_ASSET__Bfqs2Y2f__"